<script>
import { Article } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'
import moment from 'moment-timezone'

const EDITORIAL_TIME_ZONE = 'Europe/Warsaw'

function getPublicationStatus(article) {
  if (article.is_publication_scheduled) {
    const publicationAt = moment(article.publication_at)
      .tz(EDITORIAL_TIME_ZONE)
      .format('DD.MM.YYYY HH:mm')
    return `Zaplanowany — ${publicationAt}`
  }
  if (article.is_hidden) {
    return 'Ukryty'
  }
  return 'Widoczny'
}

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Article',
      addRoute: { name: 'Add Article' },
      verboseName: 'Artykuł',
      verboseNamePlural: 'Artykuły',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'title', label: 'tytuł' },
        { prop: 'slug', label: 'slug' },
        {
          prop: 'publication_status',
          label: 'Status',
          width: 220,
          formatter: getPublicationStatus
        }
      ]
    }
  },
  computed: {
    service() {
      return Article
    }
  }
}
</script>
